import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_many_cases_of_harassment_based_upon_other_occurred'

export const dataPointDefinition = {
  retracedId: 'how_many_cases_of_harassment_based_upon_other_occurred',
  name: 'How many cases of harassment based upon "Other" occurred?',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hb-5--22',
      version: '1.5.0',
      provider: 'slcp',
    },
  ],
  sortingId: 10650,
  sectionId: '2.2.5.5',
  impactArea: 'Harassment and Abuse',
  impactAreaId: 'HARRASSMENT_AND_ABUSE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
